import React from "react";
import classes from "./Timer.module.css";
import { LinearProgress } from "@mui/material";

const Timer = ({progress}) => {
  return (
    <div className={classes.container}>
      <LinearProgress variant="determinate" value={progress} />
    </div>
  );
};

export default Timer;
